import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT } from '../../../../constants/service/app/recommendReviewConstants';
import { RECOMMEND_REVIEW_LIST_URL_PATH } from '../../../../constants/service/common/urlConstants';
import recommendReviewToastMsg from '../../../../constants/service/toastMsg/recommendReviewToastMsg';
import RecommendReviewApi from '../../../../lib/api/recommend/review/RecommendReviewApi';
import {
  _setResponseListForm,
  asyncSimpleModal,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
} from '../../../../lib/common';
import toastMsg from '../../../../lib/toastMsg';
import noticeExcelDownloadResult from '../../../../lib/noticeExcelDownloadResult';
import { recommendReviewActions } from './index';

function* fetchList() {
  /**
   *   추천 상품 후기 리스트 가져오기
   */
  yield takeEvery(recommendReviewActions.GET_RECOMMEND_REVIEW_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendReviewApi.getRecommendReviewList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendReviewToastMsg.GET_RECOMMEND_REVIEW_LIST_REQUEST_SUCCESS);

        const data = {
          recommendReviewList: _setResponseListForm(result.data.recommendReviewList, result.data.totalCnt, payload),
        };

        yield put({ type: recommendReviewActions.GET_RECOMMEND_REVIEW_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendReviewToastMsg.GET_RECOMMEND_REVIEW_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 후기 상세 요청하기
   */
  yield takeEvery(recommendReviewActions.GET_RECOMMEND_REVIEW_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendReviewApi.getRecommendReviewDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendReviewToastMsg.GET_RECOMMEND_REVIEW_DETAIL_REQUEST_SUCCESS);

        const data = {
          recommendReviewDetail: {
            recommendReviewInfo: result.data.recommendReviewInfo,
            recommendReviewItemList: result.data.recommendReviewItemList,
          },
        };

        yield put({ type: recommendReviewActions.GET_RECOMMEND_REVIEW_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendReviewToastMsg.GET_RECOMMEND_REVIEW_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 후기 복사하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendReviewActions.PREPARE_COPY_RECOMMEND_REVIEW_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendReviewApi.prepareCopyRecommendReview, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendReviewToastMsg.PREPARE_COPY_RECOMMEND_REVIEW_REQUEST_SUCCESS);

        const data = {
          recommendReviewSave: {
            recommendReviewInfo: result.data.recommendReviewInfo,
            selectedRecommendReviewItemList: result.data.selectedRecommendReviewItemList,
            recommendReviewItemList: _setResponseListForm(
              result.data.recommendReviewItemList.list,
              result.data.recommendReviewItemList.totalCnt,
              payload,
            ),
          },
        };
        yield put({ type: recommendReviewActions.PREPARE_COPY_RECOMMEND_REVIEW_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendReviewToastMsg.PREPARE_COPY_RECOMMEND_REVIEW_REQUEST_ERROR, error);
    }
  });

  /**
   *  추천 상품 후기 등록하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendReviewActions.PREPARE_CREATE_RECOMMEND_REVIEW_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendReviewApi.prepareCreateRecommendReview, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(recommendReviewToastMsg.PREPARE_CREATE_RECOMMEND_REVIEW_REQUEST_SUCCESS);

      const data = {
        recommendReviewSave: {
          recommendReviewItemList: _setResponseListForm(
            result.data.recommendReviewItemList.list,
            result.data.recommendReviewItemList.totalCnt,
            payload,
          ),
        },
      };

      yield put({ type: recommendReviewActions.PREPARE_CREATE_RECOMMEND_REVIEW_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(recommendReviewToastMsg.PREPARE_CREATE_RECOMMEND_REVIEW_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 후기에 연결할 아이템 리스트 요청하기
   */
  yield takeEvery(recommendReviewActions.GET_RECOMMEND_REVIEW_ITEM_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendReviewApi.getRecommendReviewItemList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendReviewToastMsg.GET_RECOMMEND_REVIEW_ITEM_REQUEST_SUCCESS);

        const data = {
          recommendReviewItemList: _setResponseListForm(
            result.data.recommendReviewItemList.list,
            result.data.recommendReviewItemList.totalCnt,
            payload,
          ),
        };

        yield put({ type: recommendReviewActions.GET_RECOMMEND_REVIEW_ITEM_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendReviewToastMsg.GET_RECOMMEND_REVIEW_ITEM_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 후기 복사하기
   */
  yield takeEvery(recommendReviewActions.CREATE_RECOMMEND_REVIEW_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendReviewApi.createRecommendReview, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendReviewToastMsg.COPY_RECOMMEND_REVIEW_REQUEST_SUCCESS);

        reDirectPage({ path: RECOMMEND_REVIEW_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(recommendReviewToastMsg.COPY_RECOMMEND_REVIEW_REQUEST_ERROR, error);
    }
  });

  /**
   *   전체 상품 후기 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendReviewActions.GET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendReviewApi.getRecommendReviewItemListExcelDownload,
          setRequestForm(payload, true),
        );
        noticeExcelDownloadResult(payload.email, result.msg);
      } catch (error) {
        toastMsg.error(recommendReviewToastMsg.GET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
      }
    },
  );

  /**
   *   선택된 상품 후기 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendReviewActions.GET_SELECTED_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendReviewApi.getSelectedRecommendReviewItemListExcelDownload,
          setRequestForm(payload, true),
        );
        noticeExcelDownloadResult(payload.email, result.msg);
      } catch (error) {
        toastMsg.error(
          recommendReviewToastMsg.GET_SELECTED_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );

  /**
   *  상품 후기 리스트 EXCEL 업로드
   */
  yield takeEvery(recommendReviewActions.SET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(
        RecommendReviewApi.setRecommendReviewItemListExcelUpload,
        setMultipartForm(payload, true),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendReviewToastMsg.SET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS);

        /**
         *  추가하려고 하는 추천 상품 후기 아이템 개수가 초가되었을 경우
         *  업로드를 하지 못하도록 함
         */
        if (result.data.totalCnt > MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT) {
          yield asyncSimpleModal({
            type: 'error',
            title: '아이템 개수 초과',
            message: `추천 상품 후기 아이템 개수는 최대 ${MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT} 입니다.`,
          });
          return;
        }

        yield put({
          type: recommendReviewActions.SET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_UPLOAD_SUCCESS,
          payload: result.data,
        });
      }
    } catch (error) {
      toastMsg.error(recommendReviewToastMsg.SET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR, error);
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
